import { create } from "zustand";

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface IGPT {
  getSajuLoading: boolean;
  result: Result | null;
}

interface Result {
  id: number;
  name: string;
  date: string;
  imageKey: string;
  color: string;
  gift: string;
  giftKey: string;
  giftURL: string;
  food: string;
  foodKey: string;
  foodURL: string;
  number: number;
  moneyScore: number;
  moneyTitle: string;
  moneySubTitle: string;
  moneyContext: string;
  loveScore: number;
  loveTitle: string;
  loveSubTitle: string;
  loveContext: string;
  jobScore: number;
  jobTitle: string;
  jobSubTitle: string;
  jobContext: string;
  totalContext: string;
}

interface GPTAction {
  getSaju: (info: {
    id: string | number;
    birthDayJu: string;
    someDayJu: string;
    trkId: string;
    path?: string;
  }) => void;
  trackEvent: (trkId: string) => void;
}

const initialState: IGPT = {
  getSajuLoading: true,
  result: null,
};

export const useGPTStore = create<IGPT & GPTAction>((set) => ({
  ...initialState,
  getSaju: async ({ id, birthDayJu, someDayJu, trkId, path }) => {
    set({ getSajuLoading: true });
    try {
      // URLSearchParams를 사용하여 객체로 전달된 파라미터를 쿼리 스트링으로 변환합니다.
      const params = new URLSearchParams({
        birthDayJu,
        someDayJu,
        id: String(id), // 숫자 또는 기타 타입을 문자열로 변환
        trkId,
      });

      const endpoint = path ?? "/saju/getLucky";
      const separator = endpoint.startsWith("/") ? "" : "/";
      const url = `${BASE_URL}${separator}${endpoint}?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.is === "Unavailable") {
        console.log("error");
      } else {
        set({ result: data.contents });
      }
    } catch (e) {
      console.error(e);
    }
    set({ getSajuLoading: false });
  },

  trackEvent: async (trkId) => {
    // trkId를 post 요청으로 서버에 전달합니다.
    try {
      const url = `${BASE_URL}/tracking`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ trkId }),
      });
    } catch (e) {
      console.error(e);
    }
  },
}));
